export default __webpack_public_path__ + "static/media/Linkedin Learning Programing Foundation_ Web Security.0cdda685.webp";